export default () => ({
	is_multi_edit_enabled: false,
	selected_ids: {}
})
